import React, { useState } from 'react'
import { getServiceChart } from 'src/services/api/charts'
import { Props } from './types'
import { Chart } from '../components/chart'
import { utilData } from '../components/util-data'

const chartData = {
  chart: {
    type: 'column'
  },
  title: {
    text: 'Despesas classificadas por tipo de serviço'
  },
  subtitle: {},
  xAxis: {
    type: 'category',
    labels: {
      autoRotation: [-45, -90],
      style: {
        fontSize: '13px',
        fontFamily: 'Verdana, sans-serif'
      }
    }
  },
  exporting: {
    enabled: true
  },
  yAxis: {
    min: 0,
    title: {
      text: 'Despesas'
    }
  },
  legend: {
    enabled: false
  },
  tooltip: {
    pointFormat: 'Despesas em R$: <b>{point.y:.2f}</b>'
  },
  series: [
    {
      name: 'Valor',
      colorByPoint: true,
      groupPadding: 0,
      data: [] as any,
      dataLabels: {
        enabled: true,
        rotation: -90,
        color: '#FFFFFF',
        inside: true,
        verticalAlign: 'top',
        format: 'R$ {point.y:.2f}', // one decimal
        y: 10, // 10 pixels down from the top
        style: {
          fontSize: '13px',
          fontFamily: 'Verdana, sans-serif'
        }
      }
    }
  ]
}

function updateChatData(data: []) {
  return { ...chartData, series: [{ ...chartData.series, data }] }
}

export default function ServicesChart({ organization_id }: Props) {
  const [isLoading, setIsLoading] = useState(false)

  async function updateChart(monthFilter: string) {
    if (!monthFilter) {
      return chartData
    }

    setIsLoading(true)
    const date_end = utilData(monthFilter)
    const response = await getServiceChart(
      organization_id,
      monthFilter,
      date_end
    )

    setIsLoading(false)
    if (response.status !== 200) {
      return updateChatData([])
    }

    return updateChatData(response.data.data)
  }

  return <Chart updateChart={updateChart} isLoading={isLoading} />
}
